import { GridColDef } from '@mui/x-data-grid';
import moment from 'moment';

import { COLUMNS_DEFAULT_OPTIONS } from 'utils/constants/constants';
import { TranslateFunction } from 'utils/interfaces/Translations';

export const getBankInfoColumns = (
  isOnAllCompanies: boolean,
  translate: TranslateFunction
): GridColDef[] => {
  const allCompanyColumns = [
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'iban',
      headerName: translate('labels.iban'),
      align: 'left',
      headerAlign: 'left',
      sortable: false,
      flex: 0.33
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'company',
      headerName: translate('labels.company'),
      align: 'left',
      headerAlign: 'left',
      sortable: false,
      flex: 0.3
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'balance',
      headerName: translate('labels.balance'),
      align: 'left',
      headerAlign: 'left',
      flex: 0.2,
      sortable: false
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'balanceUpdatedAt',
      headerName: translate('labels.lastUpdated'),
      align: 'left',
      headerAlign: 'left',
      flex: 0.3,
      sortable: false,
      valueFormatter: (value: any) => {
        return value
          ? moment(Math.min(value, moment().toDate().getTime())).fromNow()
          : '-';
      }
    }
  ] as GridColDef[];

  const columns = [
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'iban',
      headerName: translate('labels.iban'),
      align: 'left',
      headerAlign: 'left',
      sortable: false,
      flex: 0.8
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'balance',
      headerName: translate('labels.balance'),
      align: 'left',
      headerAlign: 'left',
      flex: 0.5,
      sortable: false
    },
    {
      ...COLUMNS_DEFAULT_OPTIONS,
      field: 'balanceUpdatedAt',
      headerName: translate('labels.lastUpdated'),
      align: 'left',
      headerAlign: 'left',
      flex: 0.5,
      sortable: false,
      valueFormatter: (value: any) => {
        return value
          ? moment(Math.min(value, moment().toDate().getTime())).fromNow()
          : '-';
      }
    }
  ] as GridColDef[];

  return isOnAllCompanies ? allCompanyColumns : columns;
};
